import { SxProps, Theme } from '@mui/material'
import {
  CELL_BORDER,
  CELL_DIMMED_OPACITY,
  CELL_FONT_SIZE,
  CELL_FONT_WEIGHT,
  CELL_RADIUS,
  CELL_SELECTED_OUTLINE,
} from '../config/constants'

/**
 * Estilos de las celdas del mapa, compartidos por `MapCell` (grilla) y
 * `AisleMapCell` (vista frontal).
 */
export const mapCellStyles = {
  /**
   * `hoverBrightness` es el único parámetro que difiere entre las dos vistas:
   * la celda de pasillo es más grande y necesita menos realce para leerse.
   */
  cell: (params: {
    size: number
    background: string
    isDimmed: boolean
    isSummaryOpen: boolean
    hoverBrightness: number
  }): SxProps<Theme> => ({
    width: params.size,
    height: params.size,
    minWidth: params.size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    borderRadius: CELL_RADIUS,
    border: CELL_BORDER,
    overflow: 'hidden',
    opacity: params.isDimmed ? CELL_DIMMED_OPACITY : 1,
    transition: 'filter 0.1s, opacity 0.15s',
    '&:hover': { filter: `brightness(${params.hoverBrightness})` },
    ...(params.isSummaryOpen && {
      outline: CELL_SELECTED_OUTLINE,
      outlineOffset: '1px',
      zIndex: 2,
    }),
    background: params.background,
  }),

  /** `tabular-nums` alinea verticalmente las columnas de cifras. */
  stockText: (color: string): SxProps<Theme> => ({
    fontSize: CELL_FONT_SIZE,
    fontWeight: CELL_FONT_WEIGHT,
    color,
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    userSelect: 'none',
    pointerEvents: 'none',
  }),

  /** Candado arriba a la derecha: abajo a la derecha va la marca de slots. */
  lockIcon: (color: string): SxProps<Theme> => ({
    position: 'absolute',
    top: 1,
    right: 1,
    fontSize: 9,
    color,
    pointerEvents: 'none',
  }),
}
